import { render, staticRenderFns } from "./ComposerAtMentionPanel.vue?vue&type=template&id=1ab601d0&scoped=true"
import script from "./ComposerAtMentionPanel.vue?vue&type=script&lang=js"
export * from "./ComposerAtMentionPanel.vue?vue&type=script&lang=js"
import style0 from "./ComposerAtMentionPanel.vue?vue&type=style&index=0&id=1ab601d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab601d0",
  null
  
)

export default component.exports